import {OfferType} from "../../offer/types/OfferType";

export const getUserPreferencesToOmit = (type?: OfferType) => {
    switch (type) {
        case OfferType.FLAT:
            return ["house_storeys"];
        case OfferType.HOUSE:
            return ["floor_choices"];
        case OfferType.COMMERCIAL:
        case OfferType.MODULAR_HOUSE:
        default:
            return ["house_storeys", "floor_choices"];
    }
};
import {OfferType} from "../../offer/types/OfferType";

export const getUserPreferencesToOmit = (type?: OfferType) => {
    switch (type) {
        case OfferType.FLAT:
            return ["house_storeys"];
        case OfferType.HOUSE:
            return ["floor_choices"];
        case OfferType.COMMERCIAL:
        case OfferType.MODULAR_HOUSE:
        default:
            return ["house_storeys", "floor_choices"];
    }
};
